import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { CustomAccordion, Text } from "../../shared/uiComponents";
import { Loader, InfoRow as Row } from "../StyledComponents";

import { DispatchProperties, useSelector } from "../../redux/store";
import { getBCBAClinicalSupervisors } from "../../redux/State/userSlice";

const SupervisorList = ({ userId }: { userId: string }) => {
  const dispatch = useDispatch<DispatchProperties>();

  const clinicalSupervisors = useSelector(
    (state) => state.user.bcbasClinicalSupervisors
  );
  const loading = useSelector((state) => state.user.loadingClinicalSupervisor);

  useEffect(() => {
    if (!userId) return;
    dispatch(getBCBAClinicalSupervisors(userId));
  }, [dispatch, userId]);

  return (
    <CustomAccordion
      headerStyle={{ padding: 0 }}
      HeaderContent={() => (
        <Row>
          <Text title={"Clinical Supervisor Assigned: "} size={"smallBold"} />
          <Text
            title={`${
              !!clinicalSupervisors.length ? clinicalSupervisors.length : 0
            }`}
          />
        </Row>
      )}
      Content={() => (
        <>
          {!!clinicalSupervisors?.length ? (
            <>
              {clinicalSupervisors.map((user, index) => (
                <Text key={index} title={`${index + 1}. ${user.fullName}`} />
              ))}
            </>
          ) : (
            <Text title={"None"} />
          )}
          {loading && <Loader />}
        </>
      )}
    />
  );
};

export default SupervisorList;
